"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("@vidstack/react");
const hls_js_1 = __importDefault(require("hls.js"));
const default_1 = require("@vidstack/react/player/layouts/default");
const adjustPlayerWrapperDimensions_1 = __importDefault(require("../modules/adjustPlayerWrapperDimensions"));
const popupUtils_1 = require("../../popupUtils");
const react_2 = require("react");
function Player({ videoData }) {
    const remote = (0, react_1.useMediaRemote)();
    const [currentTime, setCurrentTime] = (0, react_2.useState)(0);
    const playerRef = (0, react_2.useRef)(null);
    const popupElement = document.getElementById("archived-video__popup");
    function timeToSeconds(timeString) {
        const [hours, minutes, seconds] = timeString.split(":").map(Number);
        return hours * 3600 + minutes * 60 + seconds;
    }
    const handleTimeUpdate = (detail) => {
        var _a, _b, _c;
        if (!popupElement) {
            return;
        }
        const startingTime = (_a = popupElement.getAttribute("data-starting-time")) !== null && _a !== void 0 ? _a : "player";
        if (startingTime === "player") {
            const newTime = Math.floor(detail.currentTime);
            const occurrenceTimeString = (_b = popupElement.getAttribute("data-occurrence-time")) !== null && _b !== void 0 ? _b : "";
            const closeAfterMs = (_c = popupElement.getAttribute("data-close-time")) !== null && _c !== void 0 ? _c : "5";
            if (newTime !== currentTime) {
                setCurrentTime(newTime);
                const occurrenceTime = timeToSeconds(occurrenceTimeString);
                (0, popupUtils_1.showPopup)("#archived-video__popup", newTime, occurrenceTime, parseInt(closeAfterMs, 10) * 1000, playerRef.current, // pause
                playerRef.current // play
                );
            }
        }
    };
    // autoplay has successfully started.
    function onAutoplay({ muted }, _) {
        console.log("autoplay started! ", `muted: ${muted}`);
    }
    // autoplay has failed.
    function onAutoplayFail({ muted, error }, nativeEvent) {
        console.log("autoplay failed! ", `muted: ${muted}`, `error: ${error}`);
        remote.mute(nativeEvent);
        remote.play(nativeEvent);
    }
    function onProviderChange(provider, _) {
        if ((0, react_1.isHLSProvider)(provider)) {
            provider.library = hls_js_1.default;
        }
    }
    return ((0, jsx_runtime_1.jsxs)(react_1.MediaPlayer, { ref: playerRef, onTimeUpdate: handleTimeUpdate, aspectRatio: "16:9", autoplay: true, className: "video-aspect-player", minLiveDVRWindow: 0, muted: false, onAutoplay: onAutoplay, onAutoplayFail: onAutoplayFail, onLoad: adjustPlayerWrapperDimensions_1.default, onProviderChange: onProviderChange, onResize: adjustPlayerWrapperDimensions_1.default, playsinline: true, src: videoData.videoUrl, streamType: videoData.streamType, children: [(0, jsx_runtime_1.jsx)(react_1.MediaProvider, {}), (0, jsx_runtime_1.jsx)(default_1.DefaultVideoLayout, { icons: default_1.defaultLayoutIcons })] }));
}
exports.default = Player;
